import React, { Fragment } from 'react';
import { Voiceover, MultipleChoice, Intro } from 'dea-core';
import img1 from '../../assets/images/U1-T1-03A.svg';
import img2 from '../../assets/images/U1-T1-03B.svg';
import img3 from '../../assets/images/U1-T1-03C.svg';
import img4 from '../../assets/images/U1-T1-03D.svg';
import img5 from '../../assets/images/U1-T1-03E.svg';
import voAudio from '../../assets/vo/Opioid-M-One-03-NEW.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript:
    'Think about your current relationship to the opioid epidemic. Take a look at the situations below and rank the importance of each one to you. There are no right or wrong answers.'
};

const options = [
  { label: 'Very important' },
  { label: 'Important' },
  { label: 'Not important' }
];

const data = [
  {
    inputType: 'radio',
    image: img1,
    question:
      'How important is it for you to know how and why we are experiencing an opioid epidemic?',
    options
  },
  {
    inputType: 'radio',
    image: img2,
    question:
      'How important is it for you to know the science of how opioids work in the brain and body?',
    options
  },
  {
    inputType: 'radio',
    image: img3,
    question:
      'How important is it for you to know how to help yourself, family, friends, or coworkers to prevent opioid use or addiction?',
    options
  },
  {
    inputType: 'radio',
    image: img4,
    question:
      'How important is it for you to know how to help yourself, family, friends, or coworkers find help in recovering from an opioid dependency?',
    options
  },
  {
    inputType: 'radio',
    image: img5,
    question:
      'How important is it for you to know how to get resources into the hands of community leaders, educators, employers, youth program leaders, and faith-based leaders?',
    options
  }
];

const feedback = {
  success: {
    title: 'Excellent',
    body:
      'Orienting yourself to the opioid epidemic is the first step in engaging with the topic in a meaningful way.'
  }
};

export default {
  title: 'The Opioid Epidemic and You',
  path: '/engage/opioid-epidemic-and-you',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="The Opioid Epidemic and You"
        direction="Answer each question."
        lead="How important are the following aspects of the opioid epidemic to you?"
      />
      <MultipleChoice data={data} feedback={feedback} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/engage/SelfAssessment.js